import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  Input,
} from '@angular/core';
import { ShimmerOptions, ShimmerTypes } from './shimmer.model';
import { SHIMMER_OPTIONS } from './shimmer.token';

@Component({
  selector: 'shimmer',
  template: ``,
  styles: [
    `
      :host {
        background: var(--shimmer-bg);
        background-image: linear-gradient(
          to right,
          var(--shimmer-color-1) 0%,
          var(--shimmer-color-2) 20%,
          var(--shimmer-color-3) 40%,
          var(--shimmer-color-4) 100%
        );
        background-repeat: no-repeat;
        background-size: 1000px 1000px;
        display: inline-block;
        position: relative;
        animation-duration: var(--duration);
        animation-fill-mode: forwards;
        animation-iteration-count: infinite;
        animation-name: shimmerAnimation;
        animation-timing-function: linear;
        -webkit-animation-duration: var(--duration);
        -webkit-animation-fill-mode: forwards;
        -webkit-animation-iteration-count: infinite;
        -webkit-animation-name: shimmerAnimation;
        -webkit-animation-timing-function: linear;
      }

      @keyframes shimmerAnimation {
        0% {
          background-position: -800px 0;
        }

        100% {
          background-position: 800px 0;
        }
      }
      @-webkit-keyframes shimmerAnimation {
        0% {
          background-position: -800px 0;
        }

        100% {
          background-position: 800px 0;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShimmerComponent {
  constructor(
    @Inject(SHIMMER_OPTIONS) private defaultOptions: ShimmerOptions
  ) {}

  @Input() type: ShimmerTypes = ShimmerTypes.LINE;

  @HostBinding('style.width')
  @Input()
  width = this.defaultOptions.width;

  @HostBinding('style.height')
  get heightValue() {
    if ([ShimmerTypes.CIRCLE, ShimmerTypes.SQUARE].includes(this.type)) {
      return this.width;
    } else {
      return this.height;
    }
  }

  @HostBinding('style.border-radius')
  get borderRadiusValue() {
    if (this.borderRadius) {
      return this.borderRadius;
    }
    if (this.rounded) {
      return this.defaultOptions.borderRadius;
    }
    switch (this.type) {
      case ShimmerTypes.CIRCLE:
        return '50%';
      case ShimmerTypes.SQUARE:
        return '0px';
      default:
        return '0px';
    }
  }

  @Input()
  height = this.defaultOptions.height;

  @HostBinding('style.--duration')
  @Input()
  duration = this.defaultOptions.duration;

  @Input() rounded = false;

  @Input() borderRadius: string | null = null;

  @HostBinding('class')
  class = 'shimmer-loader';

  @HostBinding('style.--shimmer-bg')
  get bgColor() {
    return this.defaultOptions.colors.background;
  }
  @HostBinding('style.--shimmer-color-1')
  get shimmerColorOne() {
    return this.defaultOptions.colors['1'];
  }
  @HostBinding('style.--shimmer-color-2')
  get shimmerColorTwo() {
    return this.defaultOptions.colors['2'];
  }
  @HostBinding('style.--shimmer-color-3')
  get shimmerColorThree() {
    return this.defaultOptions.colors['3'];
  }
  @HostBinding('style.--shimmer-color-4')
  get shimmerColorFour() {
    return this.defaultOptions.colors['4'];
  }
}
